import ClientLoggerFactory from "../../../logging/ClientLoggerFactory";
import { DataStore } from "aws-amplify";
import DataStoreLocationDAO from "./DataStoreLocationDAO";
import LocationDAO from "../LocationDAO";
import MockDataStoreLocationDAO from "./MockDataStoreLocationDAO";

export default class DataStoreLocationDAOFactory {
    private static readonly INSTANCE: LocationDAO = new DataStoreLocationDAO(
        DataStore,
        ClientLoggerFactory.getClientLogger("DataStoreLocationDAO")
    );
    private static readonly MOCK_INSTANCE: LocationDAO = new MockDataStoreLocationDAO(
        ClientLoggerFactory.getClientLogger("MockDataStoreLocationDAO"),
    )

    public static getInstance(): LocationDAO {
        if (process.env.REACT_APP_MOCK_ENABLED === "true") {
            return this.MOCK_INSTANCE;
        } else {
            return this.INSTANCE;
        }
    }
}
